import postApi from "@/api/post";

const state = () => ({
  all: [],
  allBulk: [],
  postUpdateBulk: {},
  postDeleteBulk: {},
  setPostBulk: {},
  deletionTask: {},
});

const getters = {};

const actions = {
  async getPosts({ commit }, params) {
    const result = await postApi.getAll(params);
    commit("setPosts", result.data);
  },

  async getPostsBulk({ commit }, params) {
    const result = await postApi.getAllBulk(params);
    commit("setPostsBulk", result.data);
  },

  async getPost({ commit }, id) {
    const result = await postApi.getOne(id);
    commit("setPost", result.data);
  },

  async create({ commit }, data) {
    const result = await postApi.create(data);
    commit("setPost", result.data);
  },

  async createBulk({ commit }, data) {
    const result = await postApi.createBulk(data);
    commit("setPostBulk", result.data);
    return result;
  },

  async update({ commit }, { id, data }) {
    const result = await postApi.update(id, data);
    commit("setPost", result.data);
  },

  async bulk({ commit }, data) {
    const result = await postApi.updateBulk(data);
    commit("setPostUpdateBulk", result.data);
  },

  async destroy({ commit }, id) {
    const result = await postApi.destroy(id);
    commit("setPost", result.data);
  },

  async destroyBulk({ commit }, data) {
    const result = await postApi.destroyBulk(data);
    commit("setPostDeleteBulk", result.data);
  },

  async createDeletionTask({ commit }, id) {
    const result = await postApi.createDeletionTask(id);
    commit("setDeletionTask", result.data);
    return result;
  },

  clearBulk({ commit }) {
    commit("setPostsBulk", []);
    commit("setPostUpdateBulk", {});
    commit("setPostDeleteBulk", {});
  },
};

const mutations = {
  setPost(state, post) {
    state.task = post;
  },
  setPosts(state, posts) {
    state.all = posts;
  },
  setPostsBulk(state, posts) {
    state.allBulk = posts;
  },
  setPostUpdateBulk(state, posts) {
    state.postUpdateBulk = posts;
  },
  setPostDeleteBulk(state, posts) {
    state.postDeleteBulk = posts;
  },
  setPostBulk(state, data) {
    state.setPostBulk = data;
  },
  setDeletionTask(state, task) {
    state.deletionTask = task;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
